import { motion } from "framer-motion";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { ContactModal } from "../../components/contactModal";

const contactChannels = [
  {
    label: "Email",
    value: "imadeabug@gmail.com",
    href: "mailto:imadeabug@gmail.com",
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="4" width="20" height="16" rx="2" />
        <path d="M22 4L12 13 2 4" />
      </svg>
    ),
  },
  {
    label: "LinkedIn",
    value: "imadeabug",
    href: "https://www.linkedin.com/company/imadeabug",
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
        <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
      </svg>
    ),
  },
];

const fadeUp = {
  hidden: { opacity: 0, y: 20 },
  visible: (i: number) => ({
    opacity: 1,
    y: 0,
    transition: { delay: i * 0.1, duration: 0.4, ease: "easeOut" },
  }),
};

export const Contact = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const { t } = useTranslation();

  return (
    <div className="flex flex-col z-10 w-full flex-1 pt-28 pb-0 px-6">
      {/* Header */}
      <motion.div
        className="text-center mb-16"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <h1 className="text-4xl md:text-5xl font-extrabold text-white uppercase mb-4">
          Get in <span className="text-green-indie">{t("contact.titleHighlight")}</span>
        </h1>
        <p className="text-gray-400 text-lg max-w-xl mx-auto">
          {t("contact.description")}
        </p>
      </motion.div>

      {/* Contact Channels */}
      <div className="max-w-2xl mx-auto w-full">
        <motion.h3
          className="text-xl font-bold text-white uppercase mb-6 text-center"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.15, duration: 0.4 }}
        >
          {t("contact.reachUs")}
        </motion.h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {contactChannels.map((channel, i) => (
            <motion.a
              key={channel.label}
              href={channel.href}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-4 bg-gray-800/60 backdrop-blur-sm border border-gray-700 rounded-xl p-5 hover:border-green-indie/50 transition-all hover:scale-[1.02] active:scale-[0.98]"
              custom={i}
              variants={fadeUp}
              initial="hidden"
              animate="visible"
            >
              <div className="text-green-indie shrink-0">{channel.icon}</div>
              <div>
                <div className="text-sm text-gray-400 font-medium">
                  {channel.label}
                </div>
                <div className="text-white font-semibold">{channel.value}</div>
              </div>
            </motion.a>
          ))}
        </div>
      </div>

      {/* Start a Project */}
      <motion.div
        className="max-w-2xl mx-auto w-full mt-12 text-center"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.3, duration: 0.5 }}
      >
        <button
          onClick={() => setModalOpen(true)}
          className="bg-green-indie hover:bg-green-600 text-black font-bold py-3 px-10 rounded-lg transition-all hover:scale-105 active:scale-95 text-lg"
        >
          {t("contact.startProject")}
        </button>
      </motion.div>

      <ContactModal isOpen={modalOpen} onClose={() => setModalOpen(false)} />
    </div>
  );
};
